module.exports = __webpack_public_path__ + "img/yuexijianshui.5ecc7cf6.jpg";